import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { AccountShell, GoogleButton } from "@/components/account";
import { useSeo } from "@/lib/seo";

export default function Signup() {
  useSeo({ title: "Create account", path: "/signup", noindex: true });
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("client");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      const u = await register({ name: name.trim(), email: email.trim().toLowerCase(), password, role });
      toast.success("Account created — check your email to verify it.");
      navigate(u.role === "tester" ? "/tester" : "/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create account");
    } finally {
      setBusy(false);
    }
  }

  return (
    <AccountShell title="Create your account" subtitle="One place for your jobs, reports, invoices and credit.">
      <GoogleButton label="Sign up with Google" role={role} />
      <div className="auth-or"><span>or</span></div>
      <div className="role-toggle" data-testid="signup-role">
        <button type="button" className={role === "client" ? "on" : ""} data-testid="signup-role-client" onClick={() => setRole("client")}>I'm a buyer</button>
        <button type="button" className={role === "tester" ? "on" : ""} data-testid="signup-role-tester" onClick={() => setRole("tester")}>I'm a tester</button>
      </div>
      <form onSubmit={submit}>
        <div className="field"><label htmlFor="su-name">Name</label>
          <input id="su-name" data-testid="signup-name" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" /></div>
        <div className="field"><label htmlFor="su-email">Email</label>
          <input id="su-email" data-testid="signup-email" type="email" autoComplete="email" required
            value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" /></div>
        <div className="field"><label htmlFor="su-password">Password</label>
          <input id="su-password" data-testid="signup-password" type="password" autoComplete="new-password" required
            value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" /></div>
        <button className="btn blue auth-submit" data-testid="signup-submit" disabled={busy}>
          {busy ? "Creating…" : "Create account"}</button>
      </form>
      <p className="auth-foot small">Already have an account? <Link to="/login" data-testid="signup-to-login">Sign in</Link></p>
    </AccountShell>
  );
}
